export default class NodeHelper {
  /**
   * Function to pass to Array.filter() function to create a list of distinct elements.
   */
  static onlyUnique(value, index, it) {
    return it.indexOf(value) === index
  }
}
